import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const SiteContentContext = createContext({
  values: {},
  loading: true,
  t: (_key, fallback) => fallback,
});

export function SiteContentProvider({ children }) {
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${BACKEND_URL}/api/site-content`)
      .then(({ data }) => mounted && setValues(data || {}))
      .catch(() => mounted && setValues({}))
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  const t = (key, fallback) => {
    const v = values[key];
    if (v === undefined || v === null || v === "") return fallback;
    return v;
  };

  return (
    <SiteContentContext.Provider value={{ values, loading, t }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}
